import classes from './footer.module.scss';
import { Box, Link } from '@mui/material';
import { CcfTypography, useTranslator } from '@nice-ccf/ui-controls';

/* eslint-disable-next-line */
export interface FooterProps {}

/**
 * Component for footer
 * @param props - FooterProps
 * @example <Footer />
 * @returns
 */
export function Footer(props: FooterProps) {
  const [translate] = useTranslator();
  return (
    <Box
      className={classes.footer}
      textAlign="center"
      fontSize={14}
      position="fixed"
      bottom={16}
    >
      <CcfTypography variant="inherit">
        {' '}
        {translate('footerText')}
        <Link classes={{ root: classes.linkText }}>
          <CcfTypography variant="inherit" translationKey="footerTextLink" />
        </Link>
      </CcfTypography>
    </Box>
  );
}

export default Footer;
